import { IndexedPublicationsSection } from 'about/ui/indexedPublications/IndexedPublicationsSection'

export const indexedPublicationsKToL: readonly IndexedPublicationsSection[] = [
  {
    letter: 'K',
    references: [
      '@bib{kalla2008haushalt};',
      '@bib{UBHD-31041537};',
      '@bib{NABU2024-51};',
      '@bib{NABU2024-90};',
      '@bib{YOS_4};',
      '@bib{CT0049};',
      '@bib{kennedy1986documentary};',
      '@bib{kennedy1960seize};',
      '@bib{LS21};',
      '@bib{LS40};',
      '@bib{LS243}; ',
      '@bib{LS243};',
      '@bib{LS146};',
      '@bib{kessler2000hellenistische};',
      '@bib{kilmer2005akkadian};',
      '@bib{CT001}; ',
      '@bib{UBHD-65324131};',
      '@bib{CT003};',
      '@bib{CT005};',
      '@bib{CT007};',
      '@bib{CT0010}; ',
      '@bib{CT009};',
      '@bib{RN2700};',
      '@bib{RN1525};',
      '@bib{RN2604};',
      '@bib{CT0021}; ',
      '@bib{CT0024};',
      '@bib{CT0025};',
      '@bib{CT0026};',
      '@bib{CT0029};',
      '@bib{CT0032}; ',
      '@bib{CT0033};',
      '@bib{RN2604a};',
      '@bib{RN1189a};',
      '@bib{RN5002};',
      '@bib{RN1189};',
      '@bib{RN1153ax}; ',
      '@bib{AOAT_358};',
      '@bib{kleinerman2011education};',
      '@bib{VS_18};',
      '@bib{VS_22}; ',
      '@bib{VS_29};',
      '@bib{RN465};',
      '@bib{RN1836vv};',
      '@bib{RN1271ae};',
      '@bib{BAM_2}; ',
      '@bib{RN1271e};',
      '@bib{RN1271c};',
      '@bib{RN1271b};',
      '@bib{RN1271a};',
      '@bib{RN1271}; ',
      '@bib{RN464};',
      '@bib{Koch-Westenholz2002OldBabylonian};',
      '@bib{vanKoppen2017Early};',
      '@bib{koshurnikov1986babylonian};',
      '@bib{SLTNi};',
      '@bib{ISET_1};',
      '@bib{ISET_2};',
      '@bib{ISET_3};',
      '@bib{RN2100ab}; ',
      '@bib{AbB_1};',
      '@bib{AbB_4};',
      '@bib{RN2100};',
      '@bib{RN1334};',
      '@bib{AbB_10}; ',
      '@bib{NABU2024-38};',
      '@bib{krueckmannNeubabylonischeRechtsUnd1933a};',
      '@bib{RN290xa};',
      '@bib{RN311c}',
    ],
  },
  {
    letter: 'L',
    references: [
      '@bib{RN444};',
      '@bib{RN2801};',
      '@bib{RN432};',
      '@bib{CT0046};',
      '@bib{RN429}; ',
      '@bib{RN790};',
      '@bib{lambert2005bilingual};',
      '@bib{lambert2005fragment}; ',
      '@bib{lambert2005hymns};',
      '@bib{lambert2005inscription}; ',
      '@bib{lambert2005introduction};',
      '@bib{lambert2005miscellaneous}; ',
      '@bib{lambert2005petitions};',
      '@bib{lambert2005rituals}; ',
      '@bib{lambert2005unidentified};',
      '@bib{lambert2005weidner};',
      '@bib{RN1023}; ',
      '@bib{RN920};',
      '@bib{RN433};',
      '@bib{RN1013};',
      '@bib{CT0046};',
      '@bib{RN435};',
      '@bib{lambert2023an};',
      '@bib{RN3006}; ',
      '@bib{RN2023bb};',
      '@bib{LS452};',
      '@bib{RN3028a};',
      '@bib{UBHD-3960407};',
      '@bib{RN2023b}; ',
      '@bib{RN2023aa};',
      '@bib{RN2023a};',
      '@bib{RN3028}; ',
      '@bib{UBHD-3937524};',
      '@bib{LS78};',
      '@bib{RN2023ab};',
      '@bib{RN311b};',
      '@bib{UBHD-370186};',
      '@bib{RN2689a};',
      '@bib{BE_A_31};',
      '@bib{RN2137}; ',
      '@bib{RN1538};',
      '@bib{PBS_10_2};',
      '@bib{PBS_10_3};',
      '@bib{PBS_12_1};',
      '@bib{PBS_10_4}; ',
      '@bib{OECT_1};',
      '@bib{OECT_2};',
      '@bib{langdon_babylonian_1927};',
      '@bib{OECT_7};',
      '@bib{langdon1930double};',
      '@bib{RN3242ax};',
      '@bib{larsen1988oldassyrian}; ',
      '@bib{lauinger2015following};',
      '@bib{lauinger2020jurisdiction};',
      '@bib{RN2248};',
      '@bib{CDLN2014-20};',
      '@bib{CDLN2014-21};',
      '@bib{CDLN2014-22};',
      '@bib{SLB_1_1};',
      '@bib{SLB_1_2};',
      '@bib{SLB_1_3};',
      '@bib{TLB_1};',
      '@bib{Leemans1990MBLETU};',
      '@bib{SLB_1_4};',
      '@bib{CT0035};',
      '@bib{PBS_13};',
      '@bib{PBS_14};',
      '@bib{PBS_15};',
      '@bib{UET_3};',
      '@bib{RN839}; ',
      '@bib{leichty2005documents};',
      '@bib{leichty2014neoassyrian};',
      '@bib{LS221};',
      '@bib{LevaviDubsar};',
      '@bib{YOS_24};',
      '@bib{lewyKeilschrifttexteAusKleinasien1932a};',
      '@bib{RN1301};',
      '@bib{RN388}; ',
      '@bib{RN384};',
      '@bib{RN1799};',
      '@bib{UET_9};',
      '@bib{Loding1976OldBabylonian};',
      '@bib{Loding1979Royal};',
      '@bib{Loding1989TwoOldBabylonian};',
      '@bib{Loretz1978};',
      '@bib{RN378};',
      '@bib{ludwig2021vokabular};',
      '@bib{YOS_2};',
      '@bib{RN2700bb};',
      '@bib{RN376a};',
      '@bib{RN376};',
      '@bib{SAA_23}',
    ],
  },
]
